import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import bannerBg from "utils/img/telegram-banner-bg.png";
import bannerMobileBg from "utils/img/telegram-banner-mobile-bg.png";
import { ReactComponent as CloseIcon } from "utils/img/banner-close.svg";
import { ReactComponent as ArrowsIcon } from "utils/img/arrows.svg";
import { useStyle } from "hooks/useStyle";
import { RESPONSIVE_SIZES } from "utils/tools";

export const TelegramBanner = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const style = useStyle();

  useEffect(() => {
    if (!localStorage.getItem("telegramBannerShow") && style.sales_telegram && !style.is_fc) {
      setIsOpen(true);
    }
  }, [style]);

  const handleCloseBanner = () => {
    localStorage.setItem("telegramBannerShow", "true");
    setIsOpen(false);
  };

  return isOpen ? (
    <StyledBanner>
      <StyledContent>
        <StyledClose onClick={handleCloseBanner} />
        <StyledTitle>{t("Узнай в нашем Telegram-канале про:")}</StyledTitle>

        <StyledInfo>
          <StyledItem>
            {t("уникальные фичи для улучшения конверсий")}
          </StyledItem>
          <StyledItem>
            {t("особенности регулирования high-risk бизнесов в разных гео")}
          </StyledItem>
          <StyledItem>{t("новые платёжные методы и гео")}</StyledItem>
        </StyledInfo>

        <StyledButton target="_blank" href={style.sales_telegram || ""}>
          {t("Подпишись")} <StyledArrow />
        </StyledButton>
      </StyledContent>
    </StyledBanner>
  ) : (
    <></>
  );
};

const StyledBanner = styled.div`
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;
`;

const StyledContent = styled.div`
  width: 600px;
  height: 600px;
  background: url(${bannerBg}) center center/cover no-repeat;
  border: none;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-decoration: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 0 58px;

  @media (${RESPONSIVE_SIZES.lg}) {
    background: url(${bannerMobileBg}) center center/cover no-repeat;
    width: calc(100% - 32px);
    height: auto;
    padding: 16px;
    max-width: 600px;
    max-height: 95%;
    overflow-y: auto;
  }
`;

const StyledTitle = styled.div`
  color: #fff;
  font-size: 35px;
  line-height: 40px;
  max-width: 387px;
  margin: 0 auto;
  margin-top: 75px;
  text-align: center;

  @media (${RESPONSIVE_SIZES.lg}) {
    font-size: 22px;
    line-height: 26px;
    max-width: 220px;
    margin-top: 0;
  }
`;

const StyledClose = styled(CloseIcon)`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  cursor: pointer;

  @media (${RESPONSIVE_SIZES.lg}) {
    width: 20px;
    height: 20px;
  }
`;

const StyledInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px 48px;
  margin-top: 40px;

  @media (${RESPONSIVE_SIZES.lg}) {
    gap: 16px 30px;
    max-width: 100%;
    margin-top: 20px;
  }
`;

const StyledItem = styled.div`
  font-size: 20px;
  line-height: 26px;
  color: #fff;

  &:nth-child(1) {
    max-width: 188px;
  }
  &:nth-child(2) {
    max-width: 247px;
  }
  &:nth-child(3) {
    max-width: 179px;
  }

  &::before {
    content: "";
    width: 10px;
    height: 10px;
    display: block;
    background: rgba(238, 186, 43, 1);
    backdrop-filter: blur(20px);
    border-radius: 1px;
    box-shadow: 0 0 20px 2px rgba(238, 186, 43, 0.6),
      0 0 80px 3px rgba(238, 186, 43, 0.4), 0 0 80px 6px rgba(238, 186, 43, 0.2);
    pointer-events: none;
    margin-bottom: 10px;
  }

  @media (${RESPONSIVE_SIZES.lg}) {
    font-size: 16px;
    position: relative;
    padding-left: 20px;
    
    &:before{
      position: absolute;
      left: 0;
      top: 8px;
    }

    &:nth-child(1) {
      max-width: 100%;
    }
    &:nth-child(2) {
      max-width: 100%;
    }
    &:nth-child(3) {
      max-width: 100%;
    }
  }
`;

const StyledButton = styled.a`
  background: linear-gradient(90deg, #eeba2b 0%, #ffef71 100%);
  padding: 25px 43px;
  font-size: 22px;
  line-height: 22px;
  color: #000;
  width: max-content;
  border-radius: 13px;
  margin-top: 50px;
  display: flex;
  align-items: center;
  text-decoration: none;
  min-width: 238px;
  box-sizing: border-box;
  justify-content: center;

  @media (${RESPONSIVE_SIZES.lg}) {
    padding: 13px 20px;
    max-width: 100%;
    width: 100%;
    margin-top: 24px;
    font-size: 18px;
  }
`;

const StyledArrow = styled(ArrowsIcon)`
  margin-left: 8px;

  @media (${RESPONSIVE_SIZES.lg}) {
    width: 16px;
  }
`;
